import React from 'react'
import styled from 'styled-components'
import { useDispatch,useSelector } from 'react-redux'
import { selectUnitPrices } from '../redux/slices/unitPrices.slice'
import { selectThicknessFilter,setThicknessFilter } from '../redux/slices/options.slice'

const ThicknessFilter = () => {
  const unitPrices = useSelector(selectUnitPrices)
  const thicknessFilter = useSelector(selectThicknessFilter)
  const dispatch = useDispatch()
  const options = Array.from(new Set(unitPrices
    .filter(u => u.thickness)
    .map(u => u.thickness)
    .sort()
  )) 
  
  const handleClick = thickness => {
    if(thicknessFilter.includes(thickness))
      dispatch(setThicknessFilter(thicknessFilter.filter(p => p !== thickness)))
    else
      dispatch(setThicknessFilter([...thicknessFilter,thickness]))
  }
  return (
    <Container>
      {options.map((r,index) => {
        return (
          <Option 
            key={index}
            selected={thicknessFilter.includes(r)}
            onClick={() => handleClick(r)}>{r}mm</Option>
        )
      })}
    </Container>
  )
}

export default ThicknessFilter 

const Container = styled.div`
  display:flex;
  gap:20px;
  flex-wrap:wrap;
`
const Option = styled.div`
  display:flex;
  border-radius:40px;
  color:${p => p.selected ? `white` : `black`};
  background-color:${p => p.selected ? `black` : `white`};
  padding:10px 20px;
  width:auto;
  flex-grow:0;
  font-size:1.1rem;
  white-space:nowrap;
  cursor:pointer;
`

